import React, { useContext, useEffect, useState } from 'react';
import Header from "src/components/common/Header";
import ClientForm from "src/components/client/ClientForm";
import { MenuContext } from 'src/context/MenuContext';
import Menu from 'src/components/common/Menu';
import { getSingleClients } from "src/store/client";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import ScrollTop from 'src/components/common/ScrollTop';
import CustomLoader from 'src/components/common/CustomLoader';

export default function EditInput() {

    const { id } = useParams();
    const dispatch = useDispatch();
    const containerStyle = { width: "90%", margin: "0 auto" };
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        dispatch(getSingleClients(id)).then((res) => {
            if (res.payload) {
                setLoading(false);
            }
        });
    }, []);

    const clickClientListBtn = () => {
        navigate('/clientList');
    }

    const { visibleMenu } = useContext(MenuContext);
    return (
        <>
            {visibleMenu && <Menu />}
            <div className={visibleMenu ? 'menu-open' : 'menu-closed'} >
                <Header sx={{ mb: 500 }} />
                <section className="container-fluid contents-top client_input">
                    <div className="text-right">
                        <button type="button" className="btn btn-default" onClick={clickClientListBtn}>
                            <span className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                            Back to List
                        </button>
                    </div>
                    {loading ? <CustomLoader /> :
                        <div style={containerStyle}>
                            <h3 className="title-style01">Modify Client Registration</h3>
                            <ClientForm id={id} />
                        </div>
                    }
                </section>
            </div>
            <ScrollTop />
        </>
    );
}
